import { type InfiniteData } from '@tanstack/query-core';

import { type Accounts, type Query } from '@pkg/graphql/codegen/graphql';

export function parseData(response: InfiniteData<Query>) {
    const pages = response?.pages?.flatMap((page: Query) => page?.accounts).filter((page) => !!page) || [];
    const pagesData = pages?.flatMap((pageData: Accounts) => pageData?.value).filter((data) => !!data) || [];
    return {
        ...response,
        pages,
        pagesData,
    };
}
